// src/components/layout/Layout.js
import React from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

export default function Layout({ children }) {
  return (
    <div style={styles.container}>
      <Sidebar />
      <div style={styles.main}>
        <Topbar />
        <div style={styles.content}>{children}</div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    height: '100vh',
    overflow: 'hidden',
    backgroundColor: '#F7F3EA',
  },
  main: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    height: '100vh',
    marginLeft: 260,
    overflow: 'hidden',
  },
  content: {
    height: '100vh',
    padding: '106px 32px 28px',
    backgroundColor: '#F7F3EA',
    overflowY: 'auto',
    overscrollBehavior: 'contain',
  },
};
